const applyImagePerfHints = (img) => {
  if (!img.hasAttribute('loading')) img.loading = 'lazy'
  if (!img.hasAttribute('decoding')) img.decoding = 'async'
  // 尽量让浏览器提前知道图片最大可用宽度，减少布局抖动
  if (!img.getAttribute('sizes')) img.setAttribute('sizes', '100vw')
}

const fancyBoxInit = (img) => {
  applyImagePerfHints(img)
  const outer = img.outerHTML
  const imgSrc = /src="(.*)"/.exec(outer)?.[1] || ''
  const imgAlt =
    /alt="(.*)"/.exec(outer)?.[1] || /title="(.*)"/.exec(outer)?.[1] || ''
  img.outerHTML = `<a class="fancy-link" href="${imgSrc}" data-fancybox="gallery" data-caption="${imgAlt}">${outer}</a>`
}

export default () => {
  /** images in home page (article abstract) */
  const abstractContentImages = document.querySelectorAll(
    '.abstract-content img',
  )
  /** images in article page */
  const articleContentImages = document.querySelectorAll('.article-entry img')

  // #region add fancybox support for images
  abstractContentImages.forEach(fancyBoxInit)
  articleContentImages.forEach(fancyBoxInit)
  // #endregion
}
